import React from 'react';
import { Link } from 'react-router-dom';
import './footer.css';

const Footer = () => {
	const ScrollToTop = () => {
		window.scrollTo(0, 0);
	};

	return (
		<React.Fragment>
			<div className="footer-container-background">
				<div className="footer-container">
					<div className="footer-links-container">
						<Link to="/home" onClick={ScrollToTop}>
							Home
						</Link>
						<Link to="/membership" onClick={ScrollToTop}>
							Membership
						</Link>
						<Link to="/all-gear" onClick={ScrollToTop}>
							Gear
						</Link>
						<Link to="/locations" onClick={ScrollToTop}>
							Locations
						</Link>
						<Link to="/our-mission" onClick={ScrollToTop}>
							Our Mission
						</Link>
					</div>
					<p className="copyright-typography">&copy; 2021 StayFit. All Rights Reserved.</p>
					<div className="company-logo-container">
						<h1 className="footer-company-logo">StayFit</h1>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Footer;
